module.exports = __webpack_public_path__ + "static/media/img5.847bac6e.jpg";